import _ from 'lodash';

import {convertDynamicColumnToColumn} from '../../../../../../../../src/components/common/table/tableColumn';
import {
  getCustomFieldsForAccountsFlat,
  getCustomFieldsForCardsFlat,
} from '../../../../../../../../src/store/data/customFields/customFieldsSelectors';
import {getContactsManagerTableState} from '../../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {tableStateIsAccountsTableState} from '../../../../../../../../src/store/panels/contacts/contactsManager/table/contactsManagerTableState';
import {compareName} from '../../../../../../../../srcCommon/helpers/localeHelpers';
import {createSelector} from '../../../../../../../../srcCommon/helpers/reselectHelpers';
import {ContactsManagerCustomFieldColumnMetadata} from './contactsManagerCustomFieldTypes';
import {getDynamicColumnConfigFromCustomFieldType, SharedColumnsEnum} from './sharedTableConfig';

export function makeGetDynamicColumns() {
  return createSelector(
    [getCustomFieldsForCardsFlat, getCustomFieldsForAccountsFlat, getContactsManagerTableState],
    (cardCustomFields, accountCustomFields, tableState) => {
      const customFields = tableStateIsAccountsTableState(tableState)
        ? accountCustomFields
        : cardCustomFields;
      return _([...customFields])
        .sort((customField1, customField2) => compareName(customField1.name, customField2.name))
        .map((customField) => {
          const columnConfig = getDynamicColumnConfigFromCustomFieldType(customField.type);
          if (!columnConfig) {
            return undefined;
          }

          return convertDynamicColumnToColumn<SharedColumnsEnum, ContactsManagerCustomFieldColumnMetadata>(
            `${customField.id}`,
            customField.name,
            columnConfig,
            {
              customField,
            },
          );
        })
        .compact()
        .value();
    },
  );
}
